import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="hero" className="relative flex min-h-[85vh] w-full items-center justify-center bg-background px-6 py-24 overflow-hidden">
      {}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-[20%] -left-[10%] h-[600px] w-[600px] rounded-full bg-secondary/5 blur-3xl" />
        <div className="absolute top-[40%] -right-[10%] h-[500px] w-[500px] rounded-full bg-primary/5 blur-3xl" />
      </div>

      <div ref={ref} className={cn("relative z-10 mx-auto flex max-w-4xl flex-col items-center text-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
        {}
        <span className="mb-6 inline-block rounded-full bg-secondary/10 px-4 py-1.5 text-sm font-medium tracking-wide text-secondary uppercase">
          Strategic Growth Consultancy
        </span>

        {}
        <h1 className="font-serif text-5xl font-medium tracking-tight text-foreground sm:text-6xl md:text-7xl lg:text-8xl">
          Growth You Own
        </h1>

        <p className="mt-4 text-xl font-medium text-secondary md:text-2xl">
          Helping Transform Higher Education
        </p>

        {}
        <p className="mt-8 max-w-2xl text-lg text-muted-foreground sm:text-xl md:text-2xl md:leading-relaxed">
          We build capability with you, not dependency on us. Co-designing
          lifelong learning ecosystems for mission-driven institutions.
        </p>

        {}
        <div className="mt-10 flex flex-col items-center gap-4 sm:flex-row sm:gap-6">
          <Button asChild size="lg" className="h-14 min-w-[200px] bg-primary text-lg font-semibold tracking-wide text-primary-foreground shadow-lg shadow-primary/20 hover:bg-primary/90">
            <Link to="https://edustrategygroup.com/schedule-your-strategy-session/">
              Start a Conversation
            </Link>
          </Button>

          <Button asChild variant="outline" size="lg" className="h-14 min-w-[200px] border-2 border-secondary bg-transparent text-lg font-semibold tracking-wide text-secondary hover:bg-secondary/10 hover:text-secondary">
            <Link to="/HowWeWorkPage">
              See How We Work
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}